<template>
  <transition name="slide-down">
    <div v-if="isVisible" class="top-banner" @click="handleClick">
      <div class="banner-content">
        <div class="banner-top-line">
          <span class="banner-text"><strong>반얀그룹이 운영하는 카시아 속초 오너스 멤버십</strong></span>
        </div>
        <div class="banner-bottom-line">
          <div class="banner-fake">
            <span class="banner-fake-item" v-for="(item, i) in fakeList" :key="i"
              :style="{ animationDelay: (i * 3) + 's' }">{{ item }} 님이 방문예약을 신청했습니다</span>
          </div>
        </div>
      </div>
      <button class="banner-close" @click.stop="closeBanner">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M18 6L6 18M6 6l12 12"/>
        </svg>
      </button>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'TopBanner',
  data() {
    return {
      isVisible: true,
      fakeList: [
        '김X영 / 010-7389-****',
        '이X준 / 010-5523-****',
        '박X현 / 010-9912-****',
        '최X서 / 010-3347-****',
        '정X민 / 010-8821-****',
        '강X은 / 010-2256-****',
        '조X호 / 010-6678-****',
        '윤X지 / 010-4491-****',
        '한X수 / 010-1134-****',
        '서X아 / 010-8762-****',
        '임X혁 / 010-3045-****',
        '오X연 / 010-5578-****',
        '신X우 / 010-9203-****',
        '장X린 / 010-6641-****',
        '송X빈 / 010-2917-****',
        '권X태 / 010-4458-****',
        '유X정 / 010-7726-****',
        '배X진 / 010-1382-****',
        '홍X석 / 010-8054-****',
        '문X희 / 010-5239-****',
      ]
    }
  },
  mounted() {
    document.body.classList.add('has-top-banner')
  },
  beforeUnmount() {
    document.body.classList.remove('has-top-banner')
  },
  methods: {
    handleClick() {
      this.$emit('open-register')
    },
    closeBanner() {
      this.isVisible = false
      document.body.classList.remove('has-top-banner')
    }
  }
}
</script>

<style scoped>
.top-banner {
  position: fixed;
  top: 60px;
  left: 0;
  right: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  background: #ffffff;
  border-bottom: 1px solid rgba(10, 28, 51, 0.3);
  cursor: pointer;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
}

.banner-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  flex: 1;
}

.banner-top-line {
  text-align: center;
}

.banner-bottom-line {
  width: 100%;
  display: flex;
  justify-content: center;
}

.banner-fake {
  position: relative;
  height: 16px;
  overflow: hidden;
  width: 100%;
  max-width: 300px;
}

.banner-fake-item {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  text-align: center;
  white-space: nowrap;
  font-family: var(--font-family, 'Noto Sans KR', sans-serif);
  font-size: 11px;
  font-weight: 500;
  color: rgba(11,11,15,0.55);
  line-height: 16px;
  opacity: 0;
  animation: bannerRoll 60s linear infinite;
}

@keyframes bannerRoll {
  0% { opacity: 0; transform: translateY(10px); }
  1% { opacity: 1; transform: translateY(0); }
  4% { opacity: 1; transform: translateY(0); }
  5% { opacity: 0; transform: translateY(-10px); }
  100% { opacity: 0; }
}

.banner-text {
  font-family: var(--font-family, 'Noto Sans KR', sans-serif);
  font-size: 15px;
  font-weight: 500;
  color: var(--le-ink, #16161C);
  letter-spacing: -0.3px;
}

.banner-text {
  font-family: var(--font-serif-kr, 'Noto Serif KR', serif);
  font-weight: 300;
}

.banner-text strong {
  font-weight: 600;
  color: var(--le-champagne-dark, #8A6D2E);
  font-family: var(--font-serif-kr, 'Noto Serif KR', serif);
}

.banner-close {
  background: none;
  border: none;
  color: rgba(11, 11, 15, 0.5);
  cursor: pointer;
  padding: 4px;
  flex-shrink: 0;
  transition: color 0.2s ease;
}

.banner-close:hover {
  color: var(--le-ink, #16161C);
}

/* 슬라이드 다운 트랜지션 */
.slide-down-enter-active {
  transition: transform 0.5s cubic-bezier(0.16, 1, 0.3, 1), opacity 0.4s ease;
}

.slide-down-leave-active {
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.slide-down-enter-from {
  transform: translateY(-100%);
  opacity: 0;
}

.slide-down-leave-to {
  transform: translateY(-100%);
  opacity: 0;
}
</style>
